import gql from 'graphql-tag';

export const getLeaderboardsByAdmin = gql`
  query getLeaderboardsByAdmin($input: inputLeaderboardsAdmin) {
    getLeaderboardsByAdmin(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      leaderboards {
        id
        name
        periodFrom
        periodTo
        active
      }
    }
  }
`;
